





































































import { Component } from "vue-property-decorator";
import TabsComponentBase from "@/app/interaction-plugins/tabs/tabs-component-base";
import UiTaskHeaderComponent from "@/app/shared/components/ui/ui-task-header-component.vue";
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';

@Component({
  components: {
    UiTaskHeaderComponent,
    HelpPopupComponent
  }
})
export default class VerticalTabsComponent extends TabsComponentBase {
  public get isFirst(): boolean {
    return this.selectedIndex === 0;
  }

  public get isLast(): boolean {
    const tabsCount: number = Object.keys(this.internalTabs).length;
    return this.selectedIndex >= tabsCount - 1;
  }

  public onMobileTabPrevClicked(): void {
    if (this.isFirst) {
      return;
    }

    this.selectedIndex--;
  }

  public onMobileTabNextClicked(): void {
    if (this.isLast) {
      return;
    }

    this.selectedIndex++;
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }
}
